module.exports = __webpack_public_path__ + "static/media/Turkey.364eb5d9.svg";